import { RootState } from "store/store";
import { UserState } from "./types";
export const selectActiveUserStatus = (store: RootState): UserState['isSignedIn'] => store.userStateSlice.isSignedIn
export const selectActiveUser = (store: RootState): UserState => store.userStateSlice
